import React, { Component } from 'react';
import styled, { css } from 'styled-components';
import redirectAppURL from '@common/redirectApp';
import Slides from './shared/Slides';
import data from '../../../templates/data';
import content from './data';
import { breakpointsMinWidth } from '../../../../../../common/styling';
import getSingleColTemplates from '../../../../../../common/utilities/getSingleColTemplates';
import { Button } from '../heroNew/shared/centerContent/components';

const Carousel = styled.div`
  width: 140px;
  height: 198px;
  display: flex;
  align-items: center;
  justify-content: center;

  @media ${breakpointsMinWidth.mobileMicroLg} {
    width: 160px;
    height: 226.5px;
  }
  @media ${breakpointsMinWidth.tabletSm} {
    width: 240px;
    height: 340px;
  }
  @media ${breakpointsMinWidth.tabletLg} {
    width: 300px;
    height: 424px;
  }
  @media ${breakpointsMinWidth.desktopSm} {
    width: 367px;
    height: 520px;
  }
`;
const CarouselWrapper = styled.div`
  width: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 32px 0 0 0;
  min-height: 611px;
  background-color: ${({ bgColor }) => bgColor || '#F8F6FF'};

  @media ${breakpointsMinWidth.tabletSm} {
    min-height: 712px;
  }
  @media ${breakpointsMinWidth.tabletMd} {
    min-height: 740px;
  }
  @media ${breakpointsMinWidth.tabletLg} {
    min-height: 812px;
  }
  @media ${breakpointsMinWidth.desktopSm} {
    min-height: 998px;
  }
  @media ${breakpointsMinWidth.desktopMd} {
    min-height: 1064px;
  }
`;
const Header = styled.div`
  margin-bottom: 82px;
  display: grid;
  grid-column-gap: 1.5rem;
  grid-template-columns: repeat(4, 1fr);

  @media ${breakpointsMinWidth.tabletSm} {
    grid-template-columns: repeat(8, 1fr);
  }

  @media ${breakpointsMinWidth.tabletMd} {
    grid-template-columns: repeat(12, 1fr);
  }
`;

const ButtonWrap = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  border: 1px solid #cfd8dc;
  grid-column: 1/-1;
  align-items: center;
  width: 200px;
  margin: auto;
  border-radius: 4px;
  padding: 0px 4px;
  height: 32px;

  @media ${breakpointsMinWidth.tabletSm} {
    width: 220px;
    height: 32px;
  }
  @media ${breakpointsMinWidth.tabletLg} {
    height: 40px;
    width: 260px;
  }
  @media ${breakpointsMinWidth.desktopMd} {
    height: 48px;
    width: 343px;
  }
`;

const Tab = styled.div`
  font-size: 11px;
  text-align: center;
  cursor: pointer;
  padding: 4px;
  background: linear-gradient(
    to right,
    #fff 0%,
    #fff 50%,
    #2364eb 50%,
    #2364eb 100%
  );
  ${(props) => {
    const { type } = props;
    if (type === 'CoverLetter') {
      return css`
        background: linear-gradient(
          to right,
          #2364eb 0%,
          #2364eb 50%,
          #fff 50%,
          #fff 100%
        );
        background-position: 100% 0;
      `;
    }

    return null;
  }}

  background-repeat: no-repeat;
  background-size: 200% 100%;
  transition: all 0.25s ease-in;

  @media ${breakpointsMinWidth.tabletSm} {
    font-size: 12px;
    padding: 4px;
  }
  @media ${breakpointsMinWidth.tabletLg} {
    padding: 8px;
    font-size: 12px;
  }
  @media ${breakpointsMinWidth.desktopMd} {
    font-size: 16px;
  }
  ${(props) => {
    const { active } = props;
    if (active)
      return css`
        color: white;
        border-radius: 2px;
        background-position: ${props.type === 'CoverLetter' ? '0 0' : '100% 0'};
      `;

    return null;
  }}
`;

const Wrap = styled.div`
  width: 100%;
`;

const ContentWrap = styled(Wrap)`
  grid-row: 1 / span 2;
  grid-column: 1 / span 4;

  padding: 0 28px;
  margin-bottom: 28px;
  text-align: center;

  @media ${breakpointsMinWidth.tabletSm} {
    justify-self: center;

    padding: 0;

    grid-row: 1 / span 1;
    grid-column: 2 / span 6;
  }

  @media ${breakpointsMinWidth.tabletMd} {
    grid-column: 2 / span 10;
    margin-bottom: 48px;
  }
  @media ${breakpointsMinWidth.tabletLg} {
    grid-column: 3 / span 8;
    margin-bottom: 48px;
  }
  @media ${breakpointsMinWidth.desktopSm} {
    margin-bottom: 80px;
  }
  @media ${breakpointsMinWidth.desktopMd} {
    margin-bottom: 94px;
  }
`;

const Heading = styled(Wrap)`
  align-items: center;
  text-align: center;
  font-size: 28px;
  line-height: 36px;
  font-weight: 400;
  color: #122241;
  margin: 0;

  @media ${breakpointsMinWidth.tabletSm} {
    font-size: 32px;
    line-height: 42px;
  }
  @media ${breakpointsMinWidth.tabletMd} {
    font-size: 32px;
    line-height: 64px;
  }
  @media ${breakpointsMinWidth.desktopMd} {
    font-size: 36px;
    line-height: 64px;
  }
`;

const Description = styled(Wrap)`
  text-align: center;
  font-size: 14px;
  line-height: 21px;
  font-weight: 400;
  padding-top: 6px;
  color: #122241;
  margin-top: 8px;

  @media ${breakpointsMinWidth.tabletSm} {
    margin-top: 8px;
  }
  @media ${breakpointsMinWidth.desktopMd} {
    font-size: 20px;
    line-height: 23px;
    margin-top: 14px;
  }
`;

class Carousel3D extends Component {
  constructor(props) {
    super(props);
    const activeData = getSingleColTemplates(
      data.GROUP1.content.resumes.templates,
    );

    this.state = {
      activeData,
      tab: content.formatType.RESUME,
    };
  }

  activateTab = (formatType) => {
    const templateData = getSingleColTemplates(
      data.GROUP1.content[formatType].templates,
    );

    this.setState({
      activeData: templateData,
      tab: formatType,
    });
  };

  render() {
    const { activeData, tab } = this.state;
    const { bgColor } = this.props;
    const { length } = activeData;
    const { RESUME, COVER_LETTER } = content.formatType;

    return (
      <CarouselWrapper bgColor={bgColor}>
        <Header>
          <ContentWrap>
            <Heading>{content.HeaderContent.Heading}</Heading>
            <Description>{content.HeaderContent.Description}</Description>
          </ContentWrap>
          <ButtonWrap>
            <Tab
              onClick={() => this.activateTab(RESUME)}
              active={tab === RESUME}
            >
              {content.TabContent.ResumeTabText}
            </Tab>
            <Tab
              onClick={() => this.activateTab(COVER_LETTER)}
              active={tab === COVER_LETTER}
              type="CoverLetter"
            >
              {content.TabContent.CoverLetterTabText}
            </Tab>
          </ButtonWrap>
        </Header>
        <Carousel>
          <Slides length={length} data={activeData} />
        </Carousel>
        <div className="py-[48px]">
          <Button
            style={{ marginTop: 0, border: '1px solid #2364eb' }}
            href={redirectAppURL({
              appType: 'GATSBY',
              path: '/drive/myDrive/?auth=Register',
            })}
            target="_blank"
            className="w-[300px] !h-[48px] !border-[#2364eb] !border-[1px] rounded-[12px]"
          >
            TRY FOR FREE
          </Button>
        </div>
      </CarouselWrapper>
    );
  }
}

export default Carousel3D;
